import { ErrorWrapper, Gutters, MainButton } from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { HeaderSearchBar } from '../../../home/components/carousel/slide/footer/HeaderSearchBar'
import { ScreenTypeProvider } from '../../../v2/state/screenTypeProvider'
import { NavigationView } from '../../layout/NavigationView'
import { ToolbarItemProps } from '../../layout/TopToolbar'

interface IBookingsListPageProps {
    children: React.ReactNode
    title: string
    subHeaderText: string
    trailingItems?: ToolbarItemProps[]
    addButtonText?: string
    onNewItemPressed: () => void
}

export const BaseBookingsListPage = ({
    children,
    title,
    subHeaderText,
    trailingItems,
    addButtonText,
    onNewItemPressed,
}: IBookingsListPageProps) => {
    const onBackPressed = () => {
        window.goBack()
    }
    return (
        <>
            <NavigationView
                usePageTransition
                navigationBarTitle={title}
                navigationBarSubtitle={subHeaderText}
                navigationBarTrailing={trailingItems}
                backButtonAction={onBackPressed}
            >
                <Gutters>
                    <Box width={'90vw'}>
                        <Stack spacing={'16px'} height={'100%'}>
                            <HeaderSearchBar />
                            <MainButton
                                id={`add-booking-button`}
                                onClick={onNewItemPressed}
                                icon="Add"
                            >
                                {addButtonText}
                            </MainButton>

                            <ErrorWrapper>
                                <ScreenTypeProvider screenType="edit">
                                    {children}
                                </ScreenTypeProvider>
                            </ErrorWrapper>
                        </Stack>
                    </Box>
                </Gutters>
            </NavigationView>
        </>
    )
}
